import React from 'react';
import '@components/integrations/Stoplight.styl';

interface StoplightProps {
  // Optional explicit image. Default is /images/logos/${name}.png if not provided.
  image?: string;
  // Optional explicit image alt text. Default is name if not provided.
  imageAltText?: string;
  // Integration name.
  name: string;
  // Button onClick handler. This should redirect to the integration's redirectURI.
  onClick: () => void;
  // State of the integration: red = broken, yellow = might have issues, green = ok.
  state: 'red' | 'yellow' | 'green';
}

export const Stoplight: React.FC<StoplightProps> = ({
  image,
  imageAltText,
  name,
  onClick,
  state,
}) => {
  return (
    <div className="oauth-card">
      <div className="stop-sign">
        <div className={state === 'red' ? 'circle-red' : 'circle'}></div>
        <div className={state === 'yellow' ? 'circle-yellow' : 'circle'}></div>
        <div className={state === 'green' ? 'circle-green' : 'circle'}></div>
      </div>
      <button className="oauth-button" onClick={onClick}>
        <img src={image ?? `/images/logos/${name}.png`} alt={imageAltText ?? name} />
      </button>
    </div>
  );
};
